<template>
    <div id="QualiscorePage" class="Page Qualiscore" v-if="data">
      <section id="Score" class="Section Section_full">
        <div class="Section_wrapper">
          <h2>Quelle note avez-vous donné à votre logement ?</h2>
          <p><strong>Selon votre perception, la qualité de votre logement est de :</strong></p>
          <!-- <Score :value="Number(data.qualiscore.value).toFixed(1)" @openPanel="$emit('openPanel', { type: 'qualiscore' })" :higher="data.qualiscore.higher" link="https://www.qualitel.org/jevalue-mon-logement/"/> -->
          <Score :value="Number(data.qualiscore.value).toFixed(1)" @openPanel="$emit('openPanel', { type: 'qualiscore' })" :higher="data.qualiscore.higher" :link="'https://www.qualitel.org/jevalue-mon-logement/barometre2019/resultats/' + String(this.$route.params.token ? this.$route.params.token : this.user.token)"/>

          <img class="Home" src="../../public/static/images/illustrations/i_house_score.svg" />
        </div>

        <div class="Jump">
          <div class="Jump_item" v-scroll-to="'#Averages'">Je compare mes résultats</div>
          <div class="Jump_item" v-scroll-to="'#Advices'" v-if="data.advices.length > 0">J'améliore mon logement</div>
        </div>
      </section>

      <section id="Averages" class="Section Section_blue">
        <img class="Shape" src="../../public/static/images/shape.svg" />
        <img class="Shape" src="../../public/static/images/shape.svg" />

        <div class="Section_wrapper">
          <h3>Je compare mon Qualiscore aux résultats du Baromètre Qualitel</h3>
          <Average v-if="data.averages.national" :value="data.averages.national.value" :label="'Moyenne nationale'" :higher="data.averages.national.higher" :user="Number(data.qualiscore.value).toFixed(1)" :desc="'des répondants* ont obtenu un Qualiscore plus élevé que le vôtre.'" />
          <Average v-if="data.averages.region" :value="data.averages.region.value" :higher="data.averages.region.higher" :label="'Moyenne : ' + data.averages.region.name" :user="Number(data.qualiscore.value).toFixed(1)" :desc="'des répondants* de ' + data.averages.region.name + ' ont obtenu un Qualiscore plus élevé que le vôtre.'" />
          <Average v-if="data.averages.housing" :value="data.averages.housing.value" :higher="data.averages.housing.higher" :label="'Moyenne : ' + data.averages.housing.name.toLowerCase()" :user="Number(data.qualiscore.value).toFixed(1)" :desc="'des répondants* de type ' + data.averages.housing.name.toLowerCase() + ' ont obtenu un Qualiscore plus élevé que le vôtre.'" />
        </div>

        <div class="Slash Slash_white"></div>
      </section>

      <p class="Averages_mentions">*4850 répondants du Baromètre Qualitel</p>
      <router-link :to="{ name: 'survey', params: { slug:  'qualiscore' } }" class="DiscoverCta"><button class="Cta Cta_line">Me comparer à d'autres données</button></router-link>

      <section id="Advices" class="Section" v-if="data.advices.length > 0">
        <div class="Section_wrapper">
          <h3>Que souhaitez-vous améliorer ?</h3>
          <p>Selon vos réponses et votre profil, voici quelques conseils pour améliorer la qualité de votre logement :</p>

          <div class="Advices">
            <!-- <AdvicesSwiper :data="data.advices" @openPanel="onOpenPanel" /> -->
            <Advice :data="advice" v-for="(advice, index) in data.advices" :key="index" @click.native="$emit('openPanel', { type: 'advice', datas: advice })"/>
          </div>
        </div>
      </section>

      <section id="Mail" class="Section">
        <img class="Shape" src="../../public/static/images/shape-cyan.svg" />
        <div class="Section_wrapper">
          <!-- <Media class="Illustration" :data="$tools.path() + '/static/datas/illustrations/coucou.json'" /> -->

          <h3>Pas si vite !</h3>
          <p>Ce serait dommage de perdre tous ces précieux conseils, non ?</p>

          <button ref="mail" class="Cta Cta_line" @click="sendMail">Je reçois mon récapitulatif par mail</button>
        </div>
      </section>

      <Footer />
    </div>
</template>

<script>
  import Vue from 'vue'
  import page from '@/mixins/page'
  import store from '@/store'
  import { mapActions, mapState } from 'vuex'

  import Score from "@/components/Score"
  import Average from "@/components/Average"
  import Advice from "@/components/Advice"
  import AdvicesSwiper from "@/components/AdvicesSwiper"
  import Media from "@/components/Media"

  import Footer from '@/components/partials/Footer'

  export default {
    name: "Qualiscore",
    mixins: [ 'page' ],
    components: { Footer, Score, Average, AdvicesSwiper, Media, Advice },
    metaInfo: {
      title: "J'évalue la qualité de mon logement - Qualitel | Particuliers",
      meta: [
        {
          property: 'og:title',
          content: "J'évalue la qualité de mon logement - Qualitel | Particuliers"
        },
        {
          property: 'og:description',

        },
        {
          property: 'og:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-1.jpg'
        },
        {
          property: 'twitter:title',
          content: "J'évalue la qualité de mon logement - Qualitel | Particuliers"
        },
        {
          property: 'twitter:description'
        },
        {
          property: 'twitter:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-1.jpg'
        }
      ]
    },
    data() {
      return {
        data: null
      }
    },
    watch: {

    },
    computed: {
      ...mapState([
        'user'
      ])
    },
    beforeRouteEnter (to, from, next) {
      let token = to.params.token || store.state.user.token
      Vue.$api.getResults(token)
      .then(response => {
        next(vm => vm.setData(response.data.participant))
      })
    },
    beforeRouteUpdate (to, from, next) {
      let token = to.params.token || this.user.token
      this.$api.getResults(token)
      .then(response => {
        next(this.setData(response.data.data))
      })
    },
    methods: {
      ...mapActions([

      ]),
      setData(data)
      {
        this.data = data
      },
      onOpenPanel(panel)
      {
        this.$emit('openPanel', panel )
      },
      fetchData () {
        this.$api.getResults(this.user.token)
        .then(response => {
          this.data = response.data.participant

          this.$nextTick( () => {

          })
        })
      },
      sendMail()
      {
        console.log('send mail')

        this.$gtm.trackEvent({ category: 'button_resultats_mail', action: 'click', label: 'resultats_recap_email' })
        this.$emit('openPanel', { type: 'email' })
        // this.$refs.mail.disabled = true
      }
    },
    created()
    {

    },
    mounted()
    {
      if (this.$route.params.token === undefined) {
        this.$gtm.trackEvent({ category: 'event_reach_page', action: 'reach', label: 'reach_page_resultats' })
      } else {
        this.$gtm.trackEvent({ category: 'event_reach_page', action: 'reach', label: 'reach_page_resultats_token' })
      }
      document.body.querySelector('.Header').style.opacity = 0
      setTimeout( () => {
        setTimeout( () => {
          document.body.querySelector('.Header').style.opacity = 1
        }, 1000)
        this.$el.querySelectorAll('.Shape').forEach( el => {
          this.$scroll.set(el, { y: -70 }, { y: 0 }, { y: -140 }, null, 0)
        })
      }, 100)
    }
  }
</script>

<style lang="stylus">
#QualiscorePage

  .Section_full

    @media $small

      min-height calc(85vh - 60px)

  .DiscoverCta

    margin auto auto 30px auto
    display table

  .Jump

    width 100%
    height 60px
    background-color white
    border-top 1px solid $n2
    display flex
    flex-direction row
    align-items stretch
    justify-content center

    &_item

      width 50%
      max-width 260px
      display flex
      flex-direction column
      align-items center
      justify-content center
      height 100%
      font-size: 14px;
      font-family $f-title
      font-weight normal
      color: $s1
      text-align: center;
      text-transform uppercase
      line-height: 20px;
      cursor pointer
      box-sizing border-box
      border-top 2px solid transparent
      transition border-color 0.2s $ease, color 0.2s $ease

      &:hover

        border-color $blue
        color $blue


  #Score

    overflow visible
    position relative
    z-index 2

    .Home

      width 220px
      position absolute
      right -25%
      bottom 25%

      @media $medium

        display none

  #Mail

    overflow initial

    .Shape

      width 445px
      height 445px
      right -120px
      top 0px

      @media $small

        opacity 0.2

    .Illustration

      width 285px
      margin auto auto 30px auto

    .Cta

      margin-top 20px
      text-transform none



  .Averages_mentions

    width 100%
    max-width 590px
    margin 0px auto 30px auto
    box-sizing border-box

    @media $small

      padding 0px 20px

  #Advices

    .Advices

      width 100%
      max-width 1215px
      margin auto
      display flex
      flex-direction row
      align-items stretch
      flex-wrap wrap
      margin-top 40px
      justify-content center

      @media $medium

        flex-direction column

      .Advice

        margin 0px 10px 20px 10px

        @media $medium

          margin 0px auto 10px auto

  #Averages

    pointer-events none

    .Section_wrapper

      padding-bottom 20px

    .Shape

      opacity 0.1

      @media $small

        display none

    .Shape:nth-child(1)

      left -150px
      height 355px
      width 355px
      bottom -90px

    .Shape:nth-child(2)

      right 25px
      height 140px
      width 140px
      top 35px

    h3

      color white
</style>
